import './styles.scss'
import React from 'react'

const Index = (props) => {
  const { onHide, children, overlay = true, confirmationDialog, backButton, className, closeButton = true } = props

  return (
    <div className={`user-settings ${className ? className : ''}`}>
      {overlay && <div className='user-settings-overlay' onClick={onHide} />}
      {confirmationDialog && <div className='user-settings-confirmation'>{confirmationDialog}</div>}
      <div className='user-settings-container px-sm-5'>
        <div className={`user-settings-header container ${backButton ? 'with-back' : ''}`}>
          {backButton ? (
            <i className='fa fa-chevron-left' onClick={onHide} />
          ) : (
            closeButton &&
            <span className='close' onClick={onHide}>
              &times;
            </span>
          )}
        </div>
        <div className='user-settings-body container'>{children}</div>
      </div>
    </div>
  )
}

export default Index
